import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Verify() {
  const { certNo } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/public/verify/${encodeURIComponent(certNo)}`)
      .then(({ data }) => setData(data))
      .catch(() => setData({ valid: false }))
      .finally(() => setLoading(false));
  }, [certNo]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="verify-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
        <div className="flex items-center gap-2 text-slate-500 text-sm mb-6">
          <ShieldCheck className="w-5 h-5 text-blue-600" /> Welfy Care Campus 修了証 検証
        </div>

        {loading ? (
          <div className="py-12 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-blue-600" /></div>
        ) : data?.valid ? (
          <div data-testid="verify-valid">
            <div className="flex items-center gap-2 text-emerald-600 mb-5">
              <CheckCircle2 className="w-8 h-8" />
              <span className="text-xl font-bold">この修了証は有効です</span>
            </div>
            <dl className="space-y-3 text-sm">
              <Row label="証明書番号" value={data.cert_no} />
              <Row label="種別" value={data.cert_type} />
              <Row label="氏名" value={data.user_name} />
              {data.training_name ? <Row label="研修名" value={data.training_name} /> : null}
              <Row label="修了日" value={data.completed_date} />
              <Row label="発行法人" value={data.company_name} />
            </dl>
          </div>
        ) : (
          <div className="text-center py-6" data-testid="verify-invalid">
            <XCircle className="w-12 h-12 text-rose-500 mx-auto mb-3" />
            <p className="text-lg font-semibold text-slate-800">証明書が見つかりません</p>
            <p className="text-sm text-slate-500 mt-1">証明書番号「{certNo}」は無効か、取り消された可能性があります。</p>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-4 border-b border-slate-100 pb-2">
      <dt className="text-slate-400 shrink-0">{label}</dt>
      <dd className="text-slate-800 font-medium text-right">{value || "-"}</dd>
    </div>
  );
}
